export default __webpack_public_path__ + "static/media/app-store-bage-white.900e5d7c.svg";